import React, {Component} from 'react'
import FontIcon from 'material-ui/FontIcon';

import './miniNotice.scss'

const MiniNotice = ({
  className,
  error,
  alert,
  success,
  header,
  note,
  children,
}) => (
  <div>
    <div className={`mini-notice ${className}`}>
      <div className="flex-center--horizontal">
        {error &&
          <FontIcon className="material-icons small-spacing2--right" style={{fontSize: 20}}>error_outline</FontIcon>
        }
        {alert &&
          <FontIcon className="material-icons small-spacing2--right" style={{fontSize: 20}}>info_outline</FontIcon>
        }
        {success &&
          <FontIcon className="material-icons small-spacing2--right" style={{fontSize: 20, color: "#49A74C"}}>check_circle</FontIcon>
        }
        <h5 className="medium-spacing2--right">{header}</h5>
      </div>
      <div className="mini-notice__note">{note || children}</div>
    </div>
  </div>
)

export default MiniNotice


// WEBPACK FOOTER //
// ./app/components/MiniNotice.js